<template>
	<div :class="bemm()">
		<div :class="bemm('spinner')" :style="spinnerStyle"></div>
	</div>
</template>
<script lang="ts" setup>
import { useBemm } from 'bemm';
import { computed } from 'vue';

const props = defineProps({
	color: {
		type: String,
		default: 'var(--color-primary)',
		description: 'Spinner color',
	},
	size: {
		type: [String, Number],
		default: '50',
		description: 'size of loader',
	},
	padding: {
		type: Number,
		default: 0,
		description: 'padding of loader',
	},
});

const bemm = useBemm('loader-spinner', {
	return: 'string',
	includeBaseClass: true,
});

const formattedSize = computed(() => {
	return String(props.size).includes('px') ? props.size : props.size + 'px';
});

const spinnerStyle = computed(() => {
	return {
		width: formattedSize.value,
		height: formattedSize.value,
		borderColor: props.color,
		borderTopColor: 'transparent',
		display: 'inline-block',
	};
});
</script>

<style lang="scss">
.loader-spinner {
	padding: var(--space);
	display: flex;
	align-items: center;
	justify-content: center;

	&__spinner {
		width: 100px;
		height: 100px;
		position: relative;
		display: block;

		&::before,
		&::after {
			content: '';
			width: 100%;
			height: 100%;
			position: absolute;
			border-radius: 50%;
			border-style: solid;
			border-color: var(--loader-color, var(--color-secondary))
				var(--loader-color, var(--color-secondary)) transparent transparent;
			border-width: 4px;
			animation:
				spin 0.5s linear infinite,
				pulse 4s ease-in-out infinite;
		}
		&::after {
			border-color: var(--loader-color, var(--color-secondary)) transparent
				transparent transparent;
			animation:
				spin 1s linear infinite,
				pulse 4s ease-in-out infinite;
		}
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
@keyframes pulse {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.1;
	}
	100% {
		opacity: 1;
	}
}
</style>
